export default {
  name: "remove",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false,
        title: $t("x058g48", "解除互联企业关系")
      }
    };
  },
  watch: {
    visible(val) {
      val && this.init();
      this.modal.visible = val;
    }
  },
  methods: {
    /* 提交事件 */
    onCommit() {
      /* 验证 */
      this.modal.loading = true;
      this.modal.loading = false;
    },
    /* 不显示弹窗 */
    clean() {
      this.$emit("close");
    },
    init() {}
  }
};